import { ContentType } from '../ContentType';
import { Messages } from '../../../../gen-src/Localize';
import { AppUrls } from '../../../app/AppUrls';
import { ConnectedOwnerFilter } from '../../components/filters/quickFilter/OwnerFilter';
import { IContentDefinition } from './IContentDefinition';
import { CommonColumns, IColumnFactoryParameters } from '../../components/listView/ListViewGridColumnGenerator';
import { DateTimeCell } from '../../components/listView/dataGridCells/DateTimeCells';
import { ConnectedModifiedTimeFilter } from '../../components/filters/quickFilter/ModifiedTimeFilter';
import { GetFlowsResult } from '../httpClient/MetaDataResults';
import { SearchResponseHitsContent } from '../../../generated/content-exploration';
import GetMetaDataRequests from '../../services/httpClient/GetMetaDataRequests';
import { IUser } from '../IUser';
import { UserMapper } from '../../../common/utils/UserMapper';
import { Flow } from '../SearchResultTypes';
import { LocationTypes } from '../ILocationInfo';
import { SortBy } from '../SortSelection';
import { defaultHeaderFormatter } from '../../components/listView/DefaultHeaderFormatter';
import { ConnectedTagFilter } from '../../components/filters/quickFilter/TagFilter';

export const flowContentDefinition: IContentDefinition<Flow, GetFlowsResult> = {
  getSectionTitle: () => Messages.FlowSectionTitle(),
  getUrl: (urls) => urls.searchFlowsUrl(),
  getPath: (urls) => urls.searchFlowsPath(),
  mapCRASSData: (crassData: SearchResponseHitsContent[]) => {
    return crassData.map((crassDataItem: SearchResponseHitsContent) => {
      return {
        crassData: crassDataItem,
        contentType: ContentType.flow,
        name: crassDataItem.title,
        id: crassDataItem.id.toString(),
        location: { name: crassDataItem.containerName || '', id: crassDataItem.projectId?.toString() || '', type: LocationTypes.Project },
        modifiedTime: crassDataItem.modifiedTime || '',
        createdAt: crassDataItem.createdTime || '',
        description: crassDataItem.description || '',
        favoritesTotal: crassDataItem.favoritesTotal,
      };
    });
  },
  mapMetadata: (searchResultItems, metadata) => {
    const metaDataUserInfo: { [ownerId: string]: IUser } = {};
    const favoriteMetaData: { [id: string]: boolean } = {};
    if (metadata.total > 0) {
      metadata.items.users.forEach((item) => {
        metaDataUserInfo[item.id] = item;
      });
      metadata.items.favorites.forEach((id) => {
        favoriteMetaData[id] = true;
      });
    }
    return searchResultItems.map((searchResultItem) => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const crassDataItem = searchResultItem.crassData!;
      const user = crassDataItem.ownerId ? metaDataUserInfo[crassDataItem.ownerId] : undefined;
      const owner = UserMapper.mapOne(user);

      return {
        ...searchResultItem,
        owner: owner,
        favorite: favoriteMetaData[crassDataItem.id.toString()] ? favoriteMetaData[crassDataItem.id.toString()] : false,
      };
    });
  },
  defaultDisplayMode: 'list',
  listViewColumns: [
    CommonColumns.name,
    CommonColumns.owner,
    CommonColumns.location,
    (parameters: IColumnFactoryParameters) => {
      return {
        name: 'modified',
        dataKey: 'modifiedTime',
        sortable: false,
        headerText: Messages.column_updated(),
        direction: 'desc',
        headerFormatter: defaultHeaderFormatter(),
        cellFormatter: DateTimeCell('modifiedTime'),
        growToFit: true,
      };
    },
    CommonColumns.description,
  ],
  maxItemCountInMixedContentTypeResultPage: 4,
  contentSpaceUrl: (urls: AppUrls, contentId: string) => urls.flowUrl(contentId),
  quickFilters: [ConnectedOwnerFilter, ConnectedModifiedTimeFilter, ConnectedTagFilter],
  getMetaDataRequests: GetMetaDataRequests.GetFlowsRequest,
  getSortOptions: () => [SortBy.getRelevancySortSelection()],
  shouldBeAvailable: () => true,
  favoritable: () => true,
};
